// import app from "@/main";
import Vue from "vue";
import * as ENDPOINTS from "./endpoints";
import { resolveRequestError } from "@/utils/auth";

export default class WalletService {

    // ========== FUNCTION TO GET ALL TRANSACTIONS ===============
    static async listTransactions( { page, limit, filters, search} ){
        try {
            const { data } = await Vue.http.get(ENDPOINTS.WALLETTRANSACTION,{
                params :{
                    filters,
                    page,
                    limit,
                    search
                }
            });
            return data;
        } catch (error) {
            resolveRequestError(error)
        }
    }

    static async reverseTransaction({transactionid}){
        try {
            const { data } = await Vue.http.put(ENDPOINTS.TRANSACTIONREVERSAL+`/${transactionid}`);
            return data;
        } catch (error) {
            resolveRequestError(error)
        }
    }

    // ============= FUNCTION TO GET ALL WITHDRAWALS =========
    static async listWithdrawals( { page, limit, filters, search } ){
        try {
            const { data } = await Vue.http.get(ENDPOINTS.WITHDRAWALTRANSACTION,{
                params :{
                    filters,
                    page,
                    limit,
                    search
                }
            });
            return data;
        } catch (error) {
            resolveRequestError(error)
        }
    }

    // =========== FUNCTION TO TAKE WITHDRAWAL ACTION ==========
    static async changeStatus( { action, withdrawal, reason } ){
        try {
            const { data } = await Vue.http.patch(ENDPOINTS.WITHDRAWALTRANSACTION, {
                action,
                withdrawal,
                reason
            });
            return data
        } catch (error) {
            resolveRequestError(error)
        }
    }

}